import { useCallback } from 'react';
import FeatherIcon from 'feather-icons-react';
import { Form, Row, Col, Button } from "reactstrap";

const AddButton = ({ onAddClick }) => {
    return (
        <Form className="mb-3">
            <Row>
                <Col md={12} className="d-flex justify-content-end">
                    <Button
                        color="primary"
                        onClick={onAddClick}
                    >
                        <FeatherIcon icon="plus-circle" size={18} style={{ marginRight: '8px' }} />
                        Add RM Vendor
                    </Button>
                </Col>
            </Row>
        </Form>
    );
};

export { AddButton };